// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import i18n from './lang'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import store from './store'
import echarts from 'echarts'
import VueClipboard from 'vue-clipboard2' //复制
import VueQriously from 'vue-qriously'
import * as filters from './utils/filters.js'
Vue.use(VueQriously)

import Trend from "vuetrend"
Vue.use(Trend)

import 'wowjs/css/libs/animate.css'
import wowjs from './utils/wow.js'
Vue.prototype.$wow = wowjs;

import './utils/flexible.js'

import '@/permission'

Vue.use(ElementUI)
Vue.use(i18n)
Vue.use(VueClipboard)
Vue.config.productionTip = false

Vue.prototype.hkdz = window.GLOBAL.hkdz;

document.title = window.GLOBAL.TITLE[store.state.lang]

Object.keys(filters).forEach(key=>{
  Vue.filter(key,filters[key])//插入过滤器名和对应方法
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  i18n,
  store
})



// WEBPACK FOOTER //
// ./src/main.js